import { ActionReducer, Action } from '@ngrx/store';
import { initialState } from './main-state';

export const UPDATE_ROUTES = 'Routes updates';
export const SAVE_ID = 'Random ID generated and saved';
export const SET_STORE = 'recovered store from localStorage';
export const RESET_ANSWERS = 'answers in Component resetted';

export const ADD_ANSWERS_GARDEN = 'Added answers for garden';
export const REMOVE_ANSWERS_GARDEN = 'Removed answers for garden';

export const ADD_ANSWERS_BALCONY = 'Added answers for balcony';
export const REMOVE_ANSWERS_BALCONY = 'Removed answers for balcony';
export const REMOVE_Q2_ANSWERS_BALCONY = 'removed all answers for balcony';

export const ADD_ANSWERS_HOUSEPLANT = 'Added answers for houseplant';
export const REMOVE_ANSWERS_HOUSEPLANT = 'Removed answers for houseplant';
export const REMOVE_Q2_ANSWERS_HOUSEPLANT =
  'removed all answers for houseplant';

export const ADD_ANSWERS_BONSAI = 'Added answers for bonsai';
export const REMOVE_ANSWERS_BONSAI = 'Removed answers for bonsai';
export const REMOVE_Q2_ANSWERS_BONSAI = 'removed all answers for bonsai';

export const ADD_ANSWERS_AGRICULTURE = 'Added answers for agriculture';
export const REMOVE_ANSWERS_AGRICULTURE = 'Removed answers for agriculture';
export const REMOVE_Q2_ANSWERS_AGRICULTURE =
  'removed all answers for agriculture';

export const ADD_ANSWERS_VERTICAL_GREENING =
  'Added answers for vertical greening';
export const REMOVE_ANSWERS_VERTICAL_GREENING =
  'Removed answers for vertical greening';
export const REMOVE_Q2_ANSWERS_VERTICAL_GREENING =
  'removed all answers for vertical greening';

export const ADD_ANSWERS_SENSORS = 'Added answers for sensors';
export const REMOVE_ANSWERS_SENSORS = 'Removed answers for sensors';
export const REMOVE_Q2_ANSWERS_SENSORS = 'removed all answers for sensors';

export const ADD_ANSWERS_ROOF_GREENING = 'Added answers for roof greening';
export const REMOVE_ANSWERS_ROOF_GREENING = 'Removed answers for roof greening';
export const REMOVE_Q2_ANSWERS_ROOF_GREENING =
  'removed all answers for roof greening';

export const UPDATE_EMAIL_CONTINUE_BUTTON_Q4 = 'Email Verification';
export const ADD_ANSWERS_MAIL = 'Added answers for Mail';
export const REMOVE_ANSWERS_MAIL = 'Removed answers for Mail';

export const ADD_ANSWERS_CONSULTING = 'Added answers for consulting';
export const REMOVE_ANSWERS_CONSULTING = 'Removed answers for consulting';

export const stateReducer: ActionReducer<any> = (
  state = initialState,
  action: Action
) => {
  switch (action.type) {
    case SET_STORE:
      return action.payload;

    case RESET_ANSWERS:
      let returnObjectReset;
      if (action.payload.question === 'q4') {
        returnObjectReset = {
          ...state,
          answers: {
            ...state.answers,
            [action.payload.area]: {
              ...state.answers[action.payload.area],
              [action.payload.question]: {
                a2: {
                  continueButton: false
                }
              }
            }
          }
        };
      } else if (
        action.payload.question === 'q1' ||
        action.payload.question === 'q2' ||
        action.payload.question === 'q3'
      ) {
        returnObjectReset = {
          ...state,
          answers: {
            ...state.answers,
            [action.payload.area]: {
              ...state.answers[action.payload.area],
              [action.payload.question]: {}
            }
          }
        };
      } else {
        returnObjectReset = { ...state };
      }

      // returnObject.answers.balcony[action.payload.name] = action.payload.answers;
      return returnObjectReset;

    case UPDATE_EMAIL_CONTINUE_BUTTON_Q4:
      return {
        ...state,
        answers: {
          ...state.answers,
          general: {
            ...state.answers.general,
            mail: {
              ...state.answers.general.mail,
              continueButton: action.payload
            }
          }
        }
      };

    case ADD_ANSWERS_MAIL:
      return {
        ...state,
        answers: {
          ...state.answers,
          general: {
            ...state.answers.general,
            mail: action.payload
          }
        }
      };

    case REMOVE_ANSWERS_MAIL:
      return {
        ...state,
        answers: {
          ...state.answers,
          general: {
            ...state.answers.general,
            mail: {
              ...state.answers.general.mail,
              active: false,
              continueButton: true
            }
          }
        }
      };

    case ADD_ANSWERS_CONSULTING:
      return {
        ...state,
        answers: {
          ...state.answers,
          general: {
            ...state.answers.general,
            consulting: action.payload
          }
        }
      };

    case REMOVE_ANSWERS_CONSULTING:
      return {
        ...state,
        answers: {
          ...state.answers,
          general: {
            ...state.answers.general,
            consulting: {
              ...state.answers.general.consultin,
              active: false,
              continueButton: true
            }
          }
        }
      };

    case UPDATE_ROUTES:
      return {
        ...state,
        routes: action.payload
      };

    case SAVE_ID:
      return {
        ...state,
        id: action.payload
      };

    case ADD_ANSWERS_GARDEN:
      const returnObject = {
        ...state,
        answers: {
          ...state.answers,
          garden: {
            ...state.answers.garden,
            [action.payload.question]: {
              ...state.answers.garden[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.garden[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.garden[action.payload.name] = action.payload.answers;
      return returnObject;

    case REMOVE_ANSWERS_GARDEN:
      const returnObject1 = {
        ...state,
        answers: {
          ...state.answers,
          garden: {
            ...state.answers.garden,
            [action.payload.question]: {
              ...state.answers.garden[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.garden[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObject1;

    case ADD_ANSWERS_BALCONY:
      const returnObjectBalcony = {
        ...state,
        answers: {
          ...state.answers,
          balcony: {
            ...state.answers.balcony,
            [action.payload.question]: {
              ...state.answers.balcony[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.balcony[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.balcony[action.payload.name] = action.payload.answers;
      return returnObjectBalcony;

    case REMOVE_ANSWERS_BALCONY:
      const returnObjectRemoveBalcony = {
        ...state,
        answers: {
          ...state.answers,
          balcony: {
            ...state.answers.balcony,
            [action.payload.question]: {
              ...state.answers.balcony[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.balcony[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObjectRemoveBalcony;

    case REMOVE_Q2_ANSWERS_BALCONY:
      return {
        ...state,
        answers: {
          ...state.answers,
          balcony: {
            q1: {
              ...state.answers.balcony.q1
            },
            q2: {},
            q3: {},
            q4: {
              a2: {
                continueButton: false
              }
            }
          }
        }
      };

    case ADD_ANSWERS_HOUSEPLANT:
      const returnObjectHouseplant = {
        ...state,
        answers: {
          ...state.answers,
          houseplant: {
            ...state.answers.houseplant,
            [action.payload.question]: {
              ...state.answers.houseplant[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.houseplant[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.houseplant[action.payload.name] = action.payload.answers;
      return returnObjectHouseplant;

    case REMOVE_ANSWERS_HOUSEPLANT:
      const returnObjectRemoveHouseplant = {
        ...state,
        answers: {
          ...state.answers,
          houseplant: {
            ...state.answers.houseplant,
            [action.payload.question]: {
              ...state.answers.houseplant[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.houseplant[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObjectRemoveHouseplant;

    case ADD_ANSWERS_BONSAI:
      const returnObjectBonsai = {
        ...state,
        answers: {
          ...state.answers,
          bonsai: {
            ...state.answers.bonsai,
            [action.payload.question]: {
              ...state.answers.bonsai[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.bonsai[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.bonsai[action.payload.name] = action.payload.answers;
      return returnObjectBonsai;

    case REMOVE_ANSWERS_BONSAI:
      const returnObjectRemoveBonsai = {
        ...state,
        answers: {
          ...state.answers,
          bonsai: {
            ...state.answers.bonsai,
            [action.payload.question]: {
              ...state.answers.bonsai[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.bonsai[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObjectRemoveBonsai;

    case ADD_ANSWERS_AGRICULTURE:
      const returnObjectAgriculture = {
        ...state,
        answers: {
          ...state.answers,
          agriculture: {
            ...state.answers.agriculture,
            [action.payload.question]: {
              ...state.answers.agriculture[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.agriculture[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.agriculture[action.payload.name] = action.payload.answers;
      return returnObjectAgriculture;

    case REMOVE_ANSWERS_AGRICULTURE:
      const returnObjectRemoveAgriculture = {
        ...state,
        answers: {
          ...state.answers,
          agriculture: {
            ...state.answers.agriculture,
            [action.payload.question]: {
              ...state.answers.agriculture[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.agriculture[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObjectRemoveAgriculture;

    case ADD_ANSWERS_VERTICAL_GREENING:
      const returnObjectverticalGreening = {
        ...state,
        answers: {
          ...state.answers,
          verticalGreening: {
            ...state.answers.verticalGreening,
            [action.payload.question]: {
              ...state.answers.verticalGreening[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.verticalGreening[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.verticalGreening[action.payload.name] = action.payload.answers;
      return returnObjectverticalGreening;

    case REMOVE_ANSWERS_VERTICAL_GREENING:
      const returnObjectRemoveverticalGreening = {
        ...state,
        answers: {
          ...state.answers,
          verticalGreening: {
            ...state.answers.verticalGreening,
            [action.payload.question]: {
              ...state.answers.verticalGreening[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.verticalGreening[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObjectRemoveverticalGreening;

    case ADD_ANSWERS_SENSORS:
      const returnObjectSensors = {
        ...state,
        answers: {
          ...state.answers,
          sensors: {
            ...state.answers.sensors,
            [action.payload.question]: {
              ...state.answers.sensors[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.sensors[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.sensors[action.payload.name] = action.payload.answers;
      return returnObjectSensors;

    case REMOVE_ANSWERS_SENSORS:
      const returnObjectRemoveSensors = {
        ...state,
        answers: {
          ...state.answers,
          sensors: {
            ...state.answers.sensors,
            [action.payload.question]: {
              ...state.answers.sensors[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.sensors[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObjectRemoveSensors;

    case ADD_ANSWERS_ROOF_GREENING:
      const returnObjectRoofGreening = {
        ...state,
        answers: {
          ...state.answers,
          roofGreening: {
            ...state.answers.roofGreening,
            [action.payload.question]: {
              ...state.answers.roofGreening[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.roofGreening[action.payload.question][
                  action.payload.answer
                ],
                ...action.payload.value,
                active: true
              }
            }
          }
        }
      };
      // returnObject.answers.roofGreening[action.payload.name] = action.payload.answers;
      return returnObjectRoofGreening;

    case REMOVE_ANSWERS_ROOF_GREENING:
      const returnObjectRemoveRoofGreening = {
        ...state,
        answers: {
          ...state.answers,
          roofGreening: {
            ...state.answers.roofGreening,
            [action.payload.question]: {
              ...state.answers.roofGreening[action.payload.question],
              [action.payload.answer]: {
                ...state.answers.roofGreening[action.payload.question][
                  action.payload.answer
                ],
                active: false
              }
            }
          }
        }
      };
      return returnObjectRemoveRoofGreening;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/app/store/stateReducer.ts